import { useEffect, useState } from 'react';

import useCurrentUser from './useCurrentUser';

export default function useHasSuperAdmin() {
  const [hasPermission, setHasPermission] = useState(false);

  const currentUser = useCurrentUser();

  useEffect(() => {
    setHasPermission(currentUser?.isSuperAdmin === true);
  }, [currentUser]);

  return hasPermission;
}
